import { some } from '@dt/fe-utils/dist/lodash'
import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { payPlanMobx } from '@mobx/mall/payment'
import GiftCardAmountModal from '../../../modal/GiftCardAmountModal'
import './index.scss'

interface IProps {
}

const SelectGiftCardModal: FC<IProps> = ({ }) => {
  const onSelect = async (card: IMemberGiftCardInfo) => {
    if (card.giftcard?.supportMallPay) {
      const amount = await modalLayer<{ card: IMemberGiftCardInfo; fristNum: number }, number>(GiftCardAmountModal, { card, fristNum: payPlanMobx.totalAmount }, 'giftCardAmountModal')
      payPlanMobx.setGiftCardPayAmount(card, amount)
    }
  }
  const changeSelect = (card, e?: any) => {
    if (findPay(card.cardNo) > 0) {
      e.stopPropagation()
      payPlanMobx.setGiftCardPayAmount(card, 0)
    }
  }
  const findPay = (cardNo) => {
    const payNum = payPlanMobx.giftCardMethodList.find(value => value.giftCard.cardNo === cardNo)?.amount || 0
    return payNum
  }

  return (
    <div className='mall-gift-card-pay'>
      {payPlanMobx.cacheGiftCardShowList.filter(x => x.giftcard.supportMallPay).map((x, index) => {
        return (
          <div
            key={x.giftcardId + '_' + x.memberCardId}
            className='gift-card'
            onClick={() => onSelect(x)}
          >
            <div className='card-icon'>
              {index === 0 ? <i className='iconfont icon-huiyuanka' /> : ''}
            </div>
            <div className='card-info-member'>
              <div className='balance'>
                <div className='name'>
                  {
                    i18n.t('pay.giftCardDisplay', {
                      name: x.giftcard.giftcardName || i18n.t('pay.giftCard'),
                      cardNo: format.shortCardNumber(x.cardNo)
                    })
                  }
                </div>
                <div className='balance-price'>
                  {i18n.t('pay.cardBalanceN', { n: format.toPrice(x.balance) })}
                </div>
              </div>
              <div className='amount-info'>
                {
                  findPay(x.cardNo) && findPay(x.cardNo) > 0 ? (
                    <div>
                      {format.toPrice(findPay(x.cardNo))}

                    </div>
                  ) : ''
                }
              </div>
            </div>
            <div className='amount-select' onClick={(e) => { (e) => changeSelect(x, e) }}>
              <i className={classNames('iconfont', (findPay(x.cardNo) > 0) ? 'icon-checked' : 'no-select')} />
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default observer(SelectGiftCardModal)
